<template>
  <div class="ai-logs-tab">
    logs
  </div>
</template>

<script setup></script>
